import { render, staticRenderFns } from "./GoodsSection.vue?vue&type=template&id=7d15b1c1&scoped=true&"
import script from "./GoodsSection.vue?vue&type=script&lang=js&"
export * from "./GoodsSection.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSection.vue?vue&type=style&index=0&id=7d15b1c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d15b1c1",
  null
  
)

export default component.exports